import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../../PosRequest/Menu/Grid/index.css";
import { getFireAlarmDisableEnableReport } from "../../../actions/fire-alarm-disable-request";
import { connect } from "react-redux";
import Spinner from "../../layout/Spinner";
import Grid from "../../PettyCash/Shared/Grid";
import DateRangeCalender from "../../PettyCash/Shared/DateRangeCalender";
var moment = require("moment");

const FireAlarmDisable = ({ getFireAlarmDisableEnableReport, report }) => {
  // Calculate three months prior from today
  var threeMonthsAgo = moment().subtract(3, "months");

  // State for Date submission
  const [formData, setFormData] = useState({
    from: threeMonthsAgo.format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
  });

  const { from, to } = formData;
  const { loading, data } = report;

  useEffect(() => {
    if (from !== "" && to !== "") {
      getFireAlarmDisableEnableReport({ fromDate: from, toDate: to });
    }
  }, [formData]);

  const reports = data
    ? data.map((d) => ({
        ...d,
        fireAlarmDevice: d.fireAlarmDevice
          .map((fd) => fd.device.name)
          .join(", "),
        createdUser: `${d.createdUser.firstName} ${d.createdUser.lastName}`
      }))
    : [];

  const headerCells = [
    {
      id: "formNumber",
      numeric: false,
      disablePadding: false,
      name: "Form No",
      propertyValue: "formNumber",
      nested: false,
      minWidth: 120,
      type: "number",
    },
    {
      id: "formStatus",
      numeric: false,
      disablePadding: false,
      name: "Form Status",
      propertyValue: "status",
      nested: true,
      nestedValue: ["name"],
      minWidth: 170,
      type: "text",
    },
    {
      id: "date",
      numeric: false,
      disablePadding: false,
      name: "Date",
      propertyValue: "date",
      nested: false,
      minWidth: 170,
      type: "date",
    },
    {
      id: "rehearsalTime",
      numeric: false,
      disablePadding: false,
      name: "Rehearsal Time From",
      propertyValue: "rehearsalTime",
      nested: false,
      minWidth: 170,
      type: "text",
    },
        {
      id: "rehearsalTimeTo",
      numeric: false,
      disablePadding: false,
      name: "Rehearsal Time To",
      propertyValue: "rehearsalTimeTo",
      nested: false,
      minWidth: 170,
      type: "text",
    },
    {
      id: "eventTime",
      numeric: false,
      disablePadding: false,
      name: "Event Time",
      propertyValue: "eventTime",
      nested: false,
      minWidth: 170,
      type: "text",
    },
        {
      id: "eventTimeTo",
      numeric: false,
      disablePadding: false,
      name: "Event Time To",
      propertyValue: "eventTimeTo",
      nested: false,
      minWidth: 170,
      type: "text",
    },
    {
      id: "functionDetails",
      numeric: false,
      disablePadding: false,
      name: "Function Details",
      propertyValue: "details",
      nested: false,
      minWidth: 170,
      type: "text",
    },
    {
      id: "beoNumber",
      numeric: false,
      disablePadding: false,
      name: "BEO Number",
      propertyValue: "beoNumber",
      nested: false,
      minWidth: 170,
      type: "text",
    },
    {
      id: "devicesToBeDisabled",
      numeric: false,
      disablePadding: false,
      name: "Devices To Be Disabled",
      propertyValue: "fireAlarmDevice",
      nested: false,
      minWidth: 300,
      type: "text",
    },
    {
      id: "createdUser",
      numeric: false,
      disablePadding: false,
      name: "Created User",
      propertyValue: "createdUser",
      nested: false,
      minWidth: 200,
      type: "text",
    },
  ];

  return (
    <div className="mt-3 mb-3">
      <div>
        <DateRangeCalender setDate={setFormData} initialState={formData} />
      </div>

      {!loading ? (
        <div>
          <div>
            <Grid headers={headerCells} data={reports} />
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

FireAlarmDisable.propTypes = {
  getFireAlarmDisableEnableReport: PropTypes.func.isRequired,
  report: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  report: state.fireAlarm.report,
});

export default connect(mapStateToProps, { getFireAlarmDisableEnableReport })(
  FireAlarmDisable
);
